/**
 * Configuración de tipos de archivo permitidos por contexto
 * Define listas blancas de extensiones y MIME types
 *
 * @description Mitiga vulnerabilidad WEB-GLOBALSYDE-22082025-M-1
 * @see docs/SECURITY_FILE_UPLOAD_MITIGATION_PLAN.md
 */

export type FileContext = 'communicationFiles' | 'documents'

interface AllowedFileTypeConfig {
  extensions: string[]
  mimeTypes: string[]
  maxSizeMB: number
  description: string
}

/**
 * Configuración de archivos permitidos por contexto de negocio
 */
export const AllowedFileTypes: Record<FileContext, AllowedFileTypeConfig> = {
  communicationFiles: {
    extensions: ['.xml', '.xlsx', '.xlsm', '.csv'],
    mimeTypes: [
      'text/xml',
      'application/xml',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/vnd.ms-excel.sheet.macroEnabled.12',
      'text/csv'
    ],
    maxSizeMB: 50,
    description: 'Archivos de comunicación (XML, Excel, CSV)'
  },

  documents: {
    extensions: ['.xml', '.xsd', '.txt', '.pdf', '.html', '.xlsx', '.xlsm', '.xsig', '.csv'],
    mimeTypes: [
      'application/xml',
      'text/xml',
      'text/plain',
      'application/pdf',
      'text/html',
      'application/xhtml+xml',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/vnd.ms-excel.sheet.macroEnabled.12',
      'text/csv',
      'application/csv'
    ],
    maxSizeMB: 50,
    description: 'Documentos genéricos (XML, XSD, TXT, PDF, HTML, Excel, XSIG, CSV)'
  }
}

/**
 * Obtiene texto legible de los tipos permitidos para mostrar al usuario
 *
 * @param context - Contexto de archivo
 * @returns String descriptivo de tipos permitidos
 */
export const getAllowedTypesText = (context: FileContext): string => {
  const config = AllowedFileTypes[context]
  return `${config.description} - Máximo ${config.maxSizeMB}MB`
}
